/* eslint-disable no-unsafe-optional-chaining */
import React from "react";
import { PATTERN_FROM_TO_PARAMS } from "../constants/params";

import { isAllowedInSelection } from "../modules/RefactoredWizard/utils/additional-options";

export const getPublickUrlByHost = (hostEnv) => {
  if (hostEnv === "develop") {
    return "https://staging.public.shopping-cart-migration.com/";
  }

  if (hostEnv === "staging") {
    return "https://staging.public.shopping-cart-migration.com/";
  }

  return "https://www.shopping-cart-migration.com/";
};

export const hasRequiredPermissions = (userPermissions, permissions) =>
  userPermissions?.some((requiredRole) => {
    const hasPermissions = permissions?.includes(requiredRole);

    return hasPermissions;
  });

export const downloadWithURL = (url) => {
  const aTag = document.createElement("a");
  aTag.href = url;
  const fileName = url.split("/").pop();
  aTag.setAttribute("download", fileName);
  document.body.appendChild(aTag);
  aTag.click();
  aTag.remove();
};

export const transformYesNoParam = (type) => {
  const paramConfig = {
    No: "0",
    no: "0",
    Yes: "1",
    yes: "1",
  };

  return type ? paramConfig[type] : "";
};

export const changeStrImgId = (str) => {
  const text = str
    ?.toLowerCase()
    ?.replace(/ /g, "")
    ?.replace(":", "")
    ?.replace("!", "")
    ?.replace("(", "")
    ?.replace(")", "")
    ?.replace(/[\s.,%]/g, "");

  return text;
};

export const isMatch = (password, confirmNewPassword) =>
  password === confirmNewPassword ||
  "Your new password and verification password do not match";

export const changeValuesUpdateProfile = (values) => {
  const {
    firstname,
    lastname,
    email,
    gender,
    phone,
    country,
    industry,
    company,
    site,
    position,
  } = values;

  const data = {
    firstname,
    lastname,
    email,
    gender,
    phone,
    country,
    industry,
    company,
    site,
    position,
  };

  Object.filter = (obj, predicate) =>
    Object.keys(obj)
      .filter((key) => predicate(obj[key]))
      .reduce((res, key) => Object.assign(res, { [key]: obj[key] }), {});

  const filtered = Object.filter(data, (score) => !!score === true);

  return filtered;
};

export const findRecordByKey = (items, key) => {
  for (const item of items || []) {
    if (item.key === key) {
      return item;
    }

    if (item.children) {
      const found = findRecordByKey(item.children, key);
      if (found) {
        return found;
      }
    }
  }

  return null;
};

export const collectAllKeys = (items) => {
  let keys = [];

  items?.forEach((item) => {
    keys.push(item.key);
    if (item.children) {
      keys = keys.concat(collectAllKeys(item.children));
    }
  });

  return keys;
};

export const getEnabledRequiredOptions = (data, requiredOptions) =>
  requiredOptions?.filter((value) => {
    const record = findRecordByKey(data, value);
    return record && !record.inactive && !record.pluginDisabled;
  }) || [];

export const collectAllowedSelectionKeys = (items) => {
  const keys = new Set();

  const walk = (list) => {
    list?.forEach((item) => {
      if (isAllowedInSelection(item)) {
        keys.add(item.key);
      }

      walk(item?.children);
    });
  };

  walk(items);
  return keys;
};

export const filterSelectedByAllowedKeys = (selectedKeys, data) => {
  const allowed = collectAllowedSelectionKeys(data);
  return selectedKeys.filter((key) => allowed.has(key));
};

export const hasSelectionChanged = (current, next) => {
  if (current.length !== next.length) {
    return true;
  }

  return current.some((key) => !next.includes(key));
};

export const addSelectWithFields = (selected, data, field) => {
  let selectedArray = [...selected];

  data?.forEach((item) => {
    if (
      selectedArray.includes(item.key) &&
      !field.value.includes(item.key) &&
      !item?.fields_select_with?.length
    ) {
      item.children?.forEach((child) => {
        if (!child?.disabled && !selectedArray.includes(child.key)) {
          selectedArray.push(child.key);
        }
      });
    }

    if (!selectedArray.includes(item.key) && field.value.includes(item.key)) {
      item.children?.forEach((child) => {
        if (
          child.connect === "parent" ||
          child.connect === "lock" ||
          item?.fields_select_with?.length
        ) {
          selectedArray = selectedArray.filter((key) => key !== child.key);
        }
      });
    }

    item.children?.forEach((child) => {
      if (
        (child.connect === "parent" ||
          child.connect === "lock" ||
          item?.fields_select_with?.length) &&
        selectedArray.includes(child.key)
      ) {
        if (!item?.disabled && !selectedArray.includes(item.key)) {
          selectedArray.push(item.key);
        }
      }

      if (child.connect === "lock" && !selectedArray.includes(child.key)) {
        if (selectedArray.includes(item.key)) {
          selectedArray = selectedArray.filter((key) => key !== item.key);
        }
      }
    });

    if (item?.children?.length) {
      selectedArray = addSelectWithFields(selectedArray, item?.children, field);
    }
  });

  return selectedArray;
};

export const addRequiredItem = (selectedItems, data, field) => {
  let selected = filterSelectedByAllowedKeys(selectedItems, data);

  data?.forEach((item) => {
    const enabledRequiredOptions = getEnabledRequiredOptions(
      data,
      item?.required_options,
    );

    if (!enabledRequiredOptions.length) {
      return;
    }

    const allValuesExist = enabledRequiredOptions.every((value) =>
      selected.includes(value),
    );

    if (
      allValuesExist &&
      !selected.includes(item.key) &&
      !field.value.includes(item.key)
    ) {
      selected.push(item.key);
    }

    if (
      !allValuesExist &&
      selected.includes(item.key) &&
      field.value.includes(item.key)
    ) {
      selected = selected.filter((elem) => elem !== item.key);
    }

    if (
      allValuesExist &&
      !selected.includes(item.key) &&
      field.value.includes(item.key)
    ) {
      selected = selected.filter(
        (elem) => !enabledRequiredOptions.includes(elem),
      );
    }

    if (
      !allValuesExist &&
      selected.includes(item.key) &&
      !field.value.includes(item.key)
    ) {
      selected.push(...enabledRequiredOptions);
    }
  });

  const selectedWithArray = addSelectWithFields(selected, data, field);
  const resArray = [...new Set(selectedWithArray)];

  return filterSelectedByAllowedKeys(resArray, data);
};

export const changeEmailsData = (data) => {
  const emails = data?.map((email) => ({
    value: email?.id,
    label: email?.email,
  }));

  return emails;
};

export const addPrefixToLinks = (prefix, links) => {
  if (prefix !== undefined) {
    links.forEach((link) => {
      links[link].to = `${prefix}/${links[link].to}`;
    });
  }

  return links;
};

export const setCookie = (
  cookieName,
  cookieValue,
  expirationDays,
  cookieDomain,
) => {
  const maxAgeDays = Number(expirationDays);
  const hasExpiration = Number.isFinite(maxAgeDays) && maxAgeDays > 0;

  const expires = hasExpiration
    ? `expires=${new Date(
        Date.now() + maxAgeDays * 24 * 60 * 60 * 1000,
      ).toUTCString()}`
    : null;

  const cookieParts = [
    `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)}`,
    "path=/",
    cookieDomain ? `Domain=${cookieDomain}` : null,
    expires,
    `secure`,
    `samesite=none`,
  ].filter(Boolean);

  document.cookie = cookieParts.join(";");
};
export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
};

export const getAllQueryParams = (searchParams) =>
  Array.from(searchParams?.keys()).reduce((params, paramName) => {
    params[paramName] = searchParams.get(paramName);

    return params;
  }, {});

export const getModifiedStore = (store) =>
  store?.charAt(0)?.toUpperCase() + store?.slice(1);

export const findTargetRegex = (routeMatch) => {
  const paramConfig = {
    to: routeMatch?.groups?.first || "",
    from: routeMatch?.groups?.second || "",
  };
  return routeMatch?.groups?.firstPrefix
    ? paramConfig[routeMatch?.groups?.firstPrefix]
    : "";
};

export const getStoreFromRoute = (routeMatch, store) => {
  const paramConfig = {
    source:
      routeMatch?.groups?.firstPrefix === "from"
        ? routeMatch?.groups?.first
        : "",
    target:
      routeMatch?.groups?.first !== "preview"
        ? findTargetRegex(routeMatch)
        : "",
    preview:
      routeMatch?.groups?.preview !== undefined
        ? findTargetRegex(routeMatch)
        : "",
  };

  return store ? paramConfig[store] : "";
};

export const getFromToSelector = (prefix) => ({
  source: getStoreFromRoute(prefix?.match(PATTERN_FROM_TO_PARAMS), "source"),
  target: getStoreFromRoute(prefix?.match(PATTERN_FROM_TO_PARAMS), "target"),
  preview: getStoreFromRoute(prefix?.match(PATTERN_FROM_TO_PARAMS), "preview"),
});

export const removeFromToPrefix = (prefix, type) => {
  const stores = getFromToSelector(prefix);

  let fromToPath = "";

  if (stores?.source && type !== "source") {
    fromToPath += `from-${stores?.source}`;
  }

  if (stores?.target && type !== "target") {
    fromToPath += `${fromToPath ? "-" : ""}to-${stores?.target}`;
  }

  if (stores?.preview && type !== "target") {
    fromToPath += `-preview`;
  }

  return fromToPath;
};

export const getScrollPage = (ref, setHiddenMenu) => {
  const element = ref.current;
  if (!element) return () => {};
  let localHidden = false;
  let locked = false;

  const lock = () => {
    locked = true;
    setTimeout(() => {
      locked = false;
    }, 350);
  };

  const HIDE_AT = 72;
  const SHOW_AT = 20;
  const HEADER_DELTA = 59;
  const MIN_SCROLLABLE = 150;

  const handleScroll = (e) => {
    if (locked) return;

    const { target } = e;
    const { scrollTop, scrollHeight, clientHeight } = target;
    const naturalScrollable = localHidden
      ? scrollHeight - clientHeight + HEADER_DELTA
      : scrollHeight - clientHeight;

    if (naturalScrollable < MIN_SCROLLABLE) {
      if (localHidden) {
        localHidden = false;
        setHiddenMenu(false);
      }
      return;
    }

    if (!localHidden && scrollTop > HIDE_AT) {
      localHidden = true;
      setHiddenMenu(true);
      lock();
    } else if (localHidden && scrollTop < SHOW_AT) {
      localHidden = false;
      setHiddenMenu(false);
      lock();
    }
  };

  element.addEventListener("scroll", handleScroll);

  return () => {
    element.removeEventListener("scroll", handleScroll);
  };
};

export const authErrorMessages = {
  toManyAttempts: "Too Many Attempts.",
  isRegistration: "The email has already been taken.",
};

export const updateSelectedRows = (
  newSelectedRows,
  dataSource,
  field,
  onValueChange,
) => {
  const nextValue = addRequiredItem(newSelectedRows, dataSource, field);
  field.onChange(nextValue);
  if (onValueChange) {
    onValueChange(nextValue);
  }
};

export const WIX_ENV = ["wixmodule", "wixmodule_staging", "wixmodule_develop"];

export const SHOPIFY_ENV = [
  "shopifymodule",
  "shopifymodule_staging",
  "shopifymodule_develop",
  "shopifymodule_local",
];

export const DEV_ENV = ["develop", "local"];

export const LOCAL_ENV = ["shopifymodule_local", "local", "wixmodule_local"];

export const getAccessCookieName = () => {
  const env = process.env.REACT_APP_NODE_ENV;

  if (env === "develop") {
    return "dev_c2c_access";
  }

  if (env === "staging") {
    return "stg_c2c_access";
  }

  return "c2c_access";
};

export const authPath = (path) => path !== "/oauth/google/callback";

export function getFormError(obj, fields = ["message", "title"]) {
  const newObj = { ...obj };
  for (const field of fields) {
    if (typeof newObj[field] === "string") {
      delete newObj[field];
    }
  }
  return newObj;
}

export const warningMessages = {
  "test-shopify-payment": {
    title:
      "Oops! It looks like your Shopify payment didn't go through. Test payments aren't allowed, so you'll need to switch to a live Shopify plan to complete the process",
    subtitle: (
      <>
        To proceed, please upgrade to a paid Shopify plan. Once you've done
        that, try your payment again!
        <br />
        If you're still having trouble, our awesome support team is available
        24/7 to help you out. Don't hesitate to reach out! We're here to make
        your migration as smooth as possible.
      </>
    ),
  },
  "payment-error": {
    title: "There was an error processing your payment.",
    subtitle:
      "We were unable to process your payment. This may be due to an issue with payment method. Please contact support so we can help resolve this.",
  },
};

export const readSession = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

export const writeSession = (key, value = "1") => {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    console.error(error);
  }
};

export const trackRegistration = (response) => {
  if (typeof window.fbq === "function") {
    window.fbq("init", window.fbPid, {
      em: response?.email,
      fn: response?.firstName,
      ln: response?.lastName,
    });
    window.fbq("track", "CompleteRegistration");
  }
};
